import httpClient from ".";
import { API_ENDPOINTS } from "./endpoints";
import type { VideoListRequest, VideoListResponse } from "@/model/videos";

export const fetchVideoList = async (
  videoListRequest: VideoListRequest,
): Promise<VideoListResponse> => {
  const url = API_ENDPOINTS.VIDEOS.LIST;
  const { token, ...payload } = videoListRequest;
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Accept-Version": "1.0",
    },
  };
  return httpClient
    .post(url, payload, config)
    .then((response) => response.data);
};
